import classNames from 'classnames/bind';
import { SearchType, searchTypeKoreanMap } from 'contexts/searchParams';
import styles from './index.module.scss';
import { areaCodeBySearchType } from './utils';

const cx = classNames.bind(styles);

interface IProps {
  searchType: SearchType;
  onClose: () => void;
  onReset: () => void;
}

export default function Header({ searchType, onClose, onReset }: IProps) {
  const areaCode = areaCodeBySearchType.get(searchType);

  return (
    <div className={cx('Header')}>
      <b className={cx('title')}>{`${searchTypeKoreanMap.get(
        searchType,
      )} 필터`}</b>
      <button
        aria-label="초기화"
        className={cx('reset')}
        type="button"
        data-event-nlog="click"
        data-event-area-code={`${areaCode}.filterrefresh`}
        onClick={onReset}
      />
      <button
        aria-label="닫기"
        className={cx('close')}
        type="button"
        data-event-nlog="click"
        data-event-area-code={`${areaCode}.filterclose`}
        onClick={onClose}
      />
    </div>
  );
}
